import { MinimalResolutionCacheHost } from "typescript";
import { IS_FIRST_LOAD, LOADING, SET_MESSAGE, SET_PERMISSION_LIST } from "../../Actions/Types";
import { getPermissions } from "../../Api/UserManagementAPI/index"; // <-- raw API function
import { getAdminPermissions } from "../../Api/AdminManagementAPI";

const navigationMap: Record<string, string> = {
  "accessibility-add-on-services": "addon-services/white-label-service",
  "manage-plan": "manage-plan",
  "orders": "orders",
  "widget-settings": "widget-settings",
  "integration-scripts": "scripts",
  "domain-report": "domain-report",
  "image-alt-text-remediation": "manage-image-alt-text",
  "my-websites": "websites",
  "report-a-problem": "report-a-problem"
};

// Service to fetch sub-user permissions
const getPermissionsService = (
  accessToken: string,
  subUserId: number,
  dispatch: Function,
  t: Function,
  navigate: Function,
  setGetPermission: Function,
  currentWebsite: any,
  parentId: number,
  is_First_load:boolean,
  department:number
) => {
  // set loading true
  dispatch({
    type: LOADING,
    payload: true,
  });
  if (parentId === 1 && department === 1) {
     // call API
  getAdminPermissions(accessToken, subUserId)
    .then((response) => {
      if (response?.data?.permissions.length > 0) {
        setGetPermission(response?.data?.permissions);
        dispatch({
          type: SET_PERMISSION_LIST,
          payload: response?.data?.permissions,
        });
        // stop loading
        dispatch({ type: LOADING, payload: false });
      }

      if (
        response?.data?.permissions.length > 0 &&
        !is_First_load
      ) {
          if (
            !window.location.pathname.includes(
              navigationMap[response?.data?.permissions[0].name]
            )
          ) {
            navigate(navigationMap[response?.data?.permissions[0].name]);
            dispatch({ type: IS_FIRST_LOAD, payload: true });
          }
        }
        dispatch({
          type: LOADING,
          payload: false,
        });
    })
    .catch((err) => {
      console.error("Error fetching permissions:", err);

      dispatch({ type: LOADING, payload: false });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          toast_message: t("Failed to fetch permissions. Please try again."),
          toast_type: "danger",
        },
      });
    });
  } else {
      // call API
    getPermissions(accessToken, subUserId)
      .then((response) => {
        if (response?.data?.length > 0) {
          setGetPermission(response?.data);
          dispatch({
            type: SET_PERMISSION_LIST,
            payload: response?.data,
          });
          // stop loading
          dispatch({ type: LOADING, payload: false });
        }
  
        const nagivateRoutesArray: any = response?.data?.filter(
          (i: any) => i?.website_domain === currentWebsite?.domain
        );
        if (
          nagivateRoutesArray.length > 0 &&
          nagivateRoutesArray[0].permissions.length > 0 &&
          !is_First_load
        ) {
          if (parentId !== 0 && parentId !== 1) {
            if (
              !window.location.pathname.includes(
                navigationMap[nagivateRoutesArray[0].permissions[0].name]
              )
            ) {
              navigate(navigationMap[nagivateRoutesArray[0].permissions[0].name]);
              dispatch({ type: IS_FIRST_LOAD, payload: true });
            }
          }
          // success message
        } else {
          dispatch({ type: LOADING, payload: false });
        }
      })
      .catch((err) => {
        console.error("Error fetching permissions:", err);
  
        dispatch({ type: LOADING, payload: false });
  
        dispatch({
          type: SET_MESSAGE,
          payload: {
            toast_message: t("Failed to fetch permissions. Please try again."),
            toast_type: "danger",
          },
        });
      });

  }

};

export { getPermissionsService };
